// Dependencies
import { bricks } from './components/home-bricks';
import navigation from './components/nav';
import filterPosts from './components/filter-posts';

// Bricks
bricks('data-bricks');

// Navigation
navigation('data-nav');

// Filter
filterPosts('data-filter');
